import { FileList } from '@applyboard/crystal-ui';
import { FileStatus } from '../user/types';

type FileListProps = {
  fileStatusList: FileStatus[];
};

export const LoansDocumentFileList = ({ fileStatusList }: FileListProps) => {
  return (
    <FileList orientation="vertical" size="sm" maxItems={4}>
      {fileStatusList.map(fileStatus => (
        <FileList.Item
          {...{ disabled: true }}
          key={fileStatus.name}
          name={fileStatus.name}
          value={fileStatus.name}
          uploading={fileStatus.status === 'uploading'}
          intent={fileStatus.status === 'failed' ? 'negative' : 'positive'}
          onRemove={null}
        />
      ))}
    </FileList>
  );
};

export default FileList;
